import { getOrdinal } from '@/lib/utils/numbers/getOrdinal'
import { shouldUseGlobalTextAlign } from '@/lib/utils/localization/isRtlLanguage'
import { rtlTextAlign } from '@/lib/utils/ui/rtlClassnames'
import useGlobalStore from '@/store/useGlobalStore'
import { clsx } from 'clsx'

export const useTranslate = () => {
  const {
    app: { translations, language },
  } = useGlobalStore()

  const translate = (
    key: string,
    variables?: Record<string, string | number>,
    isOrdinal = false,
  ): string => {
    let translation = translations ? translations[key] || key : key

    if (variables) {
      for (const [placeholder, value] of Object.entries(variables)) {
        translation = translation.replaceAll(
          new RegExp(`{{${placeholder}}}`, 'g'),
          isOrdinal && language === 'en'
            ? getOrdinal(Number(value))
            : String(value),
        )
      }
    }

    return translation
  }

  return { translate }
}

const T = ({
  className,
  children,
}: {
  className?: string
  children: string
}) => {
  const {
    app: { translations, language, marketExceptions },
  } = useGlobalStore()

  const shouldApplyRtlTextAlign = shouldUseGlobalTextAlign(
    language,
    marketExceptions || undefined,
  )
  const rtlClass = shouldApplyRtlTextAlign ? rtlTextAlign(true) : ''
  const finalClassName = clsx(className, rtlClass)

  if (!translations) return <span className={finalClassName}>{children}</span>

  return (
    <span
      className={finalClassName}
      dangerouslySetInnerHTML={{ __html: translations[children] || children }}
    />
  )
}

export default T
